import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateInventoryTransactionStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateInventoryTransactionStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldUpdateInventoryTransactionStatusAttempt', handleUpdateInventoryTransactionStatus, api);
}

function* handleUpdateInventoryTransactionStatus(api: ApprovalGateway, data: PayloadAction<TUpdateInventoryTransactionStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        inventoryLogId,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateInventoryTransactionStatus], {
        authToken,
        inventoryLogId,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldUpdateInventoryTransactionStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === TransactionStatusEnum.Cancelled
            ? SuccessMessages.InventoryTransactionCancelTransactionSuccess
            : '';

        yield put(combinedActions.goldSetConfirmUpdateInventoryTransactionStatusModalIsOpen(false));

        toast.success(successMessage);

        yield put(combinedActions.goldGetInventoryTransactionListingAttempt());
        yield put(combinedActions.goldUpdateInventoryTransactionStatusSuccess());
    }
}
